"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROCESSING = exports.LIGHT = exports.FAILED = exports.DARK = void 0;
var FAILED = exports.FAILED = 'FAILED';
var PROCESSING = exports.PROCESSING = 'PROCESSING';
var DARK = exports.DARK = 'dark';
var LIGHT = exports.LIGHT = 'light';